import request from '@/utils/request'
import axios from 'axios'

// 用裸 axios 取图形码，避免全局 request.js 拦截器把非 JSON 的 blob 响应
// 误当成 "code !== 00" 的错误。复用 baseURL 与 withCredentials 配置。
const rawCaptchaClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true
})

export function getLoginConfig () {
  return request({
    url: 'auth/config',
    method: 'get'
  })
}

// 拉一张图形验证码图片，并从响应头取 sessionKey
// 返回 { sessionKey, blobUrl }
export function fetchCaptcha () {
  return rawCaptchaClient({
    url: 'auth/captcha',
    method: 'get',
    responseType: 'blob'
  }).then(response => {
    const headers = response.headers || {}
    const sessionKey = headers['x-captcha-session'] || headers['X-Captcha-Session']
    const blobUrl = window.URL.createObjectURL(response.data)
    return { sessionKey, blobUrl }
  })
}

export function sendSmsCode (mobile, captchaSession, captchaAnswer) {
  return request({
    url: 'auth/sms/send',
    method: 'post',
    data: {
      mobile,
      captchaSession: captchaSession || '',
      captchaAnswer: captchaAnswer || ''
    }
  })
}

export function smsLogin (mobile, code) {
  return request({
    url: 'auth/sms/verify',
    method: 'post',
    data: { mobile, code }
  })
}
